export const getOccupationAllAssignedCredentialsFormValidation = (credentialName, t) => {
    switch (credentialName) {
        case 'Professional Status':
            return { maxLength: 1, maxLengthMessage: t('allCredentialsForm.errors.maxProfessionalStatus') };
        default:
            return undefined;
    }
};
